
// summit 1
export const otpsuccess = {
    data: {
        quoteId: "0Q0dq0000004lwPCAQ",
        message: "Envío de código OTP exitoso",
        ApplicationId: 3945751
    },
    error: "false"
}

// errores 

export const errornoreconozcominumero21 = {
    data: {
        quoteId: "0Q0dq0000006w1JCAQ",
        message: "No reconoce el número",
        ApplicationId: 3945751
    },
    error: true
}

export const errorseleccionanumeroerroneo22 = {
    data: {
        quoteId: "0Q0dq0000001MrJCAU",
        message: "No se seleccionó el número de teléfono",
        ApplicationId: 3945751
    },
    error: true
}

export const errorotp01escenario23 = {
    data: {
        quoteId: "0Q0dq0000001MrJCAU",
        message: "Error del sistema de OTP",
        ApplicationId: 3945751
    },
    error: true
}

export const errorotp03escenario24 = {
    data: {
        quoteId: "0Q0dq0000001MrJCAU",
        message: "Bypass del OTP debido a que el código no fue recibido",
        ApplicationId: 3945751
    },
    error: true
}

export const errorotp04escenario25 = {
    data: {
        quoteId: "0Q0dq0000001MrJCAU",
        message: "Validación fallida debido a código incorrecto",
        ApplicationId: 3945751
    },
    error: true
}

export const errorotp05escenario26 = {
    data: {
        quoteId: "0Q0dq0000001MrJCAU",
        message: "No cuenta con número telefónicos o correos electrónicos asociados al titular",
        ApplicationId: 3945751
    },
    error: true
}


export const errorNoreconozcominumero = {
    "data": {
        quoteId: "0Q0dq0000001MrJCAU",
        message: "No se seleccionó el número de teléfono",
        ApplicationId: 3945751
    },
    error: true
}

export const Error404 = {
    data: {
        quoteId: "0Q0dq0000004lwPCAQ",
        message: "Error 400 del servidor",
        ApplicationId: 3945751
    },
    error: true
}